import { first } from 'rxjs/operators';
import { AfterViewInit, Component, Directive, ElementRef, Inject, Input, OnInit, QueryList, ViewChildren, ViewEncapsulation, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { UserSummary } from '~/models/administration/user';
import { FavoritesService } from '~/services/modules/stocks/favorites';
import { SecurityService } from '~/services/security.service';
import { ThemeManagerService } from '~/services/theme-manager';
import { LayoutManagerService } from '../layout-manager';
import { LayoutComponent } from '../layout.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { SharedService } from '~/services/sharedService';

import { MenuService, MenuItem } from '~/services/administration.ts/menu';

@Directive({
    selector: '.menu--item__has_sub_menu',
    standalone: false
})
export class SubMenuElement { }

@Component({
    selector: 'asap-layout-sidebar',
    templateUrl: './sidebar.html',
    styleUrls: ['./sidebar.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'asap-layout-sidebar vertical_nav vertical_nav__minify',
    },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Sidebar implements AfterViewInit, OnInit {
  menuItems: MenuItem[] = [];
  _currentUser: UserSummary;
  theme: string = 'enterprise';
  mouseOvered: boolean;
  favoriteStarUrl: string = 'asset-add-favorite-icon-hover_new.svg';
  nonFavoriteStarUrl: string = 'stock-add-favorite-icon.svg';
  _expanded = false;

  favoritePages: any = {
    stockItems: { isFavorite: false, url: this.nonFavoriteStarUrl },
    categories: { isFavorite: false, url: this.nonFavoriteStarUrl },
    uom: { isFavorite: false, url: this.nonFavoriteStarUrl },
    customers: { isFavorite: false, url: this.nonFavoriteStarUrl },
    addresses: { isFavorite: false, url: this.nonFavoriteStarUrl },
    vendors: { isFavorite: false, url: this.nonFavoriteStarUrl },
    files: { isFavorite: false, url: this.nonFavoriteStarUrl },
    documents: { isFavorite: false, url: this.nonFavoriteStarUrl },
    videos: { isFavorite: false, url: this.nonFavoriteStarUrl },
    reports: { isFavorite: false, url: this.nonFavoriteStarUrl },
    forecast: { isFavorite: false, url: this.nonFavoriteStarUrl },
    locations: { isFavorite: false, url: this.nonFavoriteStarUrl },
    locationTypes: { isFavorite: false, url: this.nonFavoriteStarUrl },
    facility: { isFavorite: false, url: this.nonFavoriteStarUrl },
    building: { isFavorite: false, url: this.nonFavoriteStarUrl },
    floor: { isFavorite: false, url: this.nonFavoriteStarUrl },
    receive: { isFavorite: false, url: this.nonFavoriteStarUrl },
    issue: { isFavorite: false, url: this.nonFavoriteStarUrl },
    move: { isFavorite: false, url: this.nonFavoriteStarUrl },
    dispose: { isFavorite: false, url: this.nonFavoriteStarUrl },
    stockDisposeAuthorizationTransaction: { isFavorite: false, url: this.nonFavoriteStarUrl },
    stockAdjustAuthorizationTransaction: { isFavorite: false, url: this.nonFavoriteStarUrl },
    return: { isFavorite: false, url: this.nonFavoriteStarUrl },
    pack: { isFavorite: false, url: this.nonFavoriteStarUrl },
    ship: { isFavorite: false, url: this.nonFavoriteStarUrl },
    'kitting': { isFavorite: false, url: this.nonFavoriteStarUrl },
    breakdown: { isFavorite: false, url: this.nonFavoriteStarUrl },
    'adjust-inventory': { isFavorite: false, url: this.nonFavoriteStarUrl },
    picklist: { isFavorite: false, url: this.nonFavoriteStarUrl },
    'physical-inventory': { isFavorite: false, url: this.nonFavoriteStarUrl },
    'stock-cycle-count': { isFavorite: false, url: this.nonFavoriteStarUrl },
    'stock-cycle-count-adjust': { isFavorite: false, url: this.nonFavoriteStarUrl },
    'stock-to-asset': { isFavorite: false, url: this.nonFavoriteStarUrl },
    checkout: { isFavorite: false, url: this.nonFavoriteStarUrl },
    checkin: { isFavorite: false, url: this.nonFavoriteStarUrl },
    'purchaseOrders': { isFavorite: false, url: this.nonFavoriteStarUrl },
    'salesOrders': { isFavorite: false, url: this.nonFavoriteStarUrl },
    history: { isFavorite: false, url: this.nonFavoriteStarUrl },
    'receive-history': { isFavorite: false, url: this.nonFavoriteStarUrl },
    'move-history': { isFavorite: false, url: this.nonFavoriteStarUrl },
    'checkin-history': { isFavorite: false, url: this.nonFavoriteStarUrl },
    'checkout-history': { isFavorite: false, url: this.nonFavoriteStarUrl },
    'issue-history': { isFavorite: false, url: this.nonFavoriteStarUrl },
    'dispose-history': { isFavorite: false, url: this.nonFavoriteStarUrl },
    'stockDisposeReport': { isFavorite: false, url: this.nonFavoriteStarUrl },
    'return-history': { isFavorite: false, url: this.nonFavoriteStarUrl },
    'pack-history': { isFavorite: false, url: this.nonFavoriteStarUrl },
    'ship-history': { isFavorite: false, url: this.nonFavoriteStarUrl },
    disposeTo: { isFavorite: false, url: this.nonFavoriteStarUrl },
    'adjustInventory-history': {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    'stockPhysicalInventoryHistory': {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    'stockCycleCountHistory': {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    'stockCycleCountAdjustHistory': {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    'assembleHistory': {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assets": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "asset-models": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "asset-models-2": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "asset-types": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "conditions": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "fundingsource": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "statuses": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "asset-reservation": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetcheckin-transaction": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetcheckout-transactions": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetdispose-transactions": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetreceive-transactions": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetmove-transactions": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetadjust-transactions": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetadjust-authorization": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "asset-all-history": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetmove-transactions-history": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetcheckout-transactions-history": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetcheckin-transactions-history": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetdispose-transactions-history": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetreceive-transactions-history": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    'asset-edit-log': {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    'departments': {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    'barcode-label': {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    'barcode-catalog': {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    'pre-printed-label': {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetphysicalinventory-transactions": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetphysicalinventory-transactions-history": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetphysicalinventory-history": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetdepreciation-transactions": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "stockdispose-authorization-history": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "stockadjust-authorization-history": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetDisposeAuthorizationTransaction": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetAdjustAuthorizationTransaction": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetdispose-authorization": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetdispose-authorization-history": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetadjust-authorization-history": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetadjust-transactions-history": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetcyclecount-transactions": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetcyclecountadjust-transactions": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "assetcyclecount-history": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "checkout-transactions": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "checkin-transactions": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "checkout-transactions-history": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    "checkin-transactions-history": {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    'site-transfers': {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    'site-transfer-out': {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    'site-transfer-in': {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    'siteTransferHistory': {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    },
    'site-transfer-history': {
      isFavorite: false,
      url: this.nonFavoriteStarUrl,
    }
  };

  showTextBox: { [key: string]: boolean } = {};

  @ViewChildren(SubMenuElement, { read: ElementRef })
  private subMenus: QueryList<ElementRef>;
  @Input() base: string;

  constructor(
    private router: Router,
    private _themeManager: ThemeManagerService,
    private _layoutComponent: LayoutComponent,
    private _favoritesService: FavoritesService,
    private _layoutManagerService: LayoutManagerService,
    private _securityService: SecurityService,
    public _sharedService: SharedService,
    private _menuService: MenuService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this._themeManager.themeChange.subscribe((data) => {
      if (data) {
        this.theme = data;
      }
    });

    this._sharedService.TitleChanged.subscribe((x) => {
      if (x) {
        this.loadMenu();
      }
    });

    this._getFavoritePages();

    this._layoutManagerService.favoritesChange.subscribe((data) => {
      if (data) {
        for (let key in this.favoritePages) {
          this.favoritePages[key] = {
            isFavorite: false,
            url: this.nonFavoriteStarUrl,
          };
        }
        data.forEach((fav: any) => {
          const pageKey = fav.page || fav.Page;
          if (pageKey) {
            this.favoritePages[pageKey] = {
              isFavorite: true,
              url: this.favoriteStarUrl,
            };
          }
        });
      }
    });

    this._currentUser = this._securityService.currentUser;
  }

  getFavoriteUrl(scope: string): string {
    if (!scope) return this.nonFavoriteStarUrl;
    return this.favoritePages[scope]?.url || this.nonFavoriteStarUrl;
  }

  ngOnInit() {
    this.loadMenu();
  }

  loadMenu() {
    this._menuService.getSidebarMenu(this.base).subscribe((menu) => {
      this.menuItems = menu;
    });
  }

  ngAfterViewInit() {
    this.subMenus.changes.subscribe(() => {
      this.initSubMenu();
    });
    this.initSubMenu();
    this._sharedService.base = this.base;
  }

  getFavoriteScope(child: MenuItem): string {
    if (!child) return '';
    if (child.route) {
      if (child.route.includes('barcode-label')) return 'barcode-label';
      if (child.route.includes('barcode-catalog')) return 'barcode-catalog';
      if (child.route.includes('pre-printed-label')) return 'pre-printed-label';
    }
    return child.scope || '';
  }

  hasAddForm(child: MenuItem): boolean {
    if (!child || !child.route) return false;
    const route = child.route.toLowerCase();
    const scope = (child.scope || '').toLowerCase();

    if (
      route.includes('/transaction') ||
      route.includes('/history') ||
      route.includes('authorization') ||
      route.includes('pre-printed-label') ||
      route.includes('/tools') ||
      route.includes('site-transfer') ||
      scope.includes('site-transfer') ||
      scope.includes('authorization') ||
      child.isAuthorization
    ) {
      return false;
    }
    return true;
  }

  _openChildForm(child: MenuItem) {
    if (!child) return;
    let formName = child.scope;
    if (child.route) {
      if (child.route.includes('barcode-label')) {
        formName = 'barcodeLabel';
      } else if (child.route.includes('barcode-catalog')) {
        formName = 'barcodeCatalog';
      } else if (child.route.includes('/report/reports') || child.scope === 'report-reports') {
        formName = 'reports';
      } else if (child.route.includes('/report/forecast') || child.scope === 'report-forecast') {
        formName = 'forecast';
      }
    }
    this._openForm(formName);
  }

  _openForm(formName: string) {
    if (!formName) return;

    if (formName === 'barcode-label' || formName === 'labels') {
      formName = 'barcodeLabel';
    } else if (formName === 'barcode-catalog') {
      formName = 'barcodeCatalog';
    } else if (formName === 'report-reports') {
      formName = 'reports';
    } else if (formName === 'report-forecast') {
      formName = 'forecast';
    }

    const isAssetModule = this.base === 'asset' || (this.router.url && this.router.url.includes('/asset'));
    var _dialogModel: any = {
      componentName: formName,
      model: {
        isAsset: isAssetModule,
        accessFrom: isAssetModule ? 'assets' : 'stocks'
      },
      pageState: PageState.ADD,
    };
    this._sharedService.openDialog.emit(_dialogModel);
  }

  _navigate(url: string) {
    this.router.navigate([url]);
  }

  _navigateWithOutlet(url: string, outlet: string) {
    this.router.navigate([{ outlets: { 'asset': ['CommonDepartment'] } }], { skipLocationChange: true });
  }

  _favorite(pageName: string, pageCategory: string) {
    const model: any = {};
    model.Page = pageName;
    model.Category = pageCategory;
    this._favoritesService.updateFavorites(model).subscribe(() => {
      this._getFavoritePages();
    });
  }

  _getFavoritePages() {
    this._favoritesService.getFavorites().subscribe((response: any) => {
      this._layoutManagerService.setFavorites(response);
    });
  }

  _activeState(item: MenuItem) {
    const url = this.router.url;
    if (item.route) {
      return url === item.route || url.startsWith(item.route + '/');
    }
    if (item.children) {
      return item.children.some(child => child.route && (url === child.route || url.startsWith(child.route + '/')));
    }
    return false;
  }

  closeTextbox(pageName: string, event: any) {
    this._menuService.getSidebarMenu(this.base).subscribe(() => {
      // Logic for editing page titles
      // We will refresh the titles by fetching from the backend
      this.loadMenu();
    });
    this.showTextBox = {};
  }

  canAccess(scope: string, operation: string) {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }

  private initSubMenu() {
    const self = this;
    const addListener = (element: any) => {
      if (element.nativeElement.abcAddAttached) return;
      element.nativeElement.abcAddAttached = true;

      element.nativeElement.abcAdd = function () {
        element.nativeElement.classList.add('menu--subitens__opened');
        const subMenu = element.nativeElement.querySelector('.sub_menu');
        if (subMenu) {
          subMenu.style.top = '';
          subMenu.style.bottom = '';
          subMenu.style.maxHeight = '';
          subMenu.style.overflowY = '';

          const isMinified = self.document.body.querySelector('.vertical_nav__minify');
          if (isMinified) {
            const rect = subMenu.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            if (rect.bottom > viewportHeight) {
              const parentRect = element.nativeElement.getBoundingClientRect();
              const targetTop = (viewportHeight - parentRect.top) - rect.height - 10;
              const minTop = -parentRect.top + 10;
              subMenu.style.top = `${Math.max(targetTop, minTop)}px`;
              subMenu.style.maxHeight = `${viewportHeight - 20}px`;
              subMenu.style.overflowY = 'auto';
            }
          }
        }
      };
      element.nativeElement.addEventListener('mouseenter', element.nativeElement.abcAdd);

      element.nativeElement.abcRemove = function () {
        element.nativeElement.classList.remove('menu--subitens__opened');
        const subMenu = element.nativeElement.querySelector('.sub_menu');
        if (subMenu) {
          subMenu.style.top = '';
          subMenu.style.bottom = '';
          subMenu.style.maxHeight = '';
          subMenu.style.overflowY = '';
        }
      };
      element.nativeElement.addEventListener('mouseleave', element.nativeElement.abcRemove);
    };

    this.subMenus.forEach((element: any) => {
      addListener(element);
    });
  }

  toggleMenuEvents() {
    this._expanded = !this._expanded;
    this.document.body.classList.toggle('sidebar-opened');
    if (this._expanded) {
      this.subMenus.forEach((element: any) => {
        let abcAdd = element.nativeElement.abcAdd;
        element.nativeElement.removeEventListener('mouseenter', abcAdd);
        let abcRemove = element.nativeElement.abcRemove;
        element.nativeElement.removeEventListener('mouseleave', abcRemove);
        element.nativeElement.abcAddAttached = false;
      });
    }
    else {
      this.initSubMenu();
    }
  }
}

